import { SelectInputItem } from '@fmnts/declarative-forms';
import { distinctUntilChanged, map, OperatorFunction } from 'rxjs';
import { bySelectItemValueEqeqeq } from '../../util/by-select-item-value';

/**
 * Maps the emitted value to one of the given `items`,
 * by comparing it with their values.
 *
 * @param items Select items
 */
export function mapToSelectedItem(
  items: SelectInputItem[],
): OperatorFunction<unknown, SelectInputItem | undefined> {
  return (obs$) =>
    obs$.pipe(
      map((value) => items.find(bySelectItemValueEqeqeq(value))),
      distinctUntilChanged(
        (x, y) => (x === undefined && y === undefined) || x?.value === y?.value,
      ),
    );
}
